import { i18n } from "../i18n";

export default class NumberUtils {

    public static maxDecimals(decimals = -1) {
        return decimals >= 0 ? decimals : 9;
    }

    public static stringify(num: number | null, numDecimals = -1, useGrouping = true, locale: string = i18n.locale, removeTrailingZero = false): string {
        if (!num && num !== 0) {
            return "";
        }
        const options = {
            useGrouping,
            minimumFractionDigits: numDecimals > -1 && !removeTrailingZero ? numDecimals : 0,
            maximumFractionDigits: this.maxDecimals(numDecimals)
        };
        const str = new Intl.NumberFormat(locale, options).format(num);
        return str;
    }

    public static currency(num: number | null, locale: string = i18n.locale): string {
        if (!num && num !== 0) {
            return "";
        }
        return new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(num);
    }

    public static parse(val: string | null, locale: string = i18n.locale, numDecimals = -1): number | null {
        if (!val) {
            return null;
        }

        const [thousandsSymbol, decimalsSymbol] = this.computeSeperators(locale);

        const thousandsSep = new RegExp(`\\${thousandsSymbol}`, "g");

        const str = val.replace(thousandsSep, "").replace(decimalsSymbol, ".");
        const parsed = parseFloat(str);
        return parsed;
    }

    public static computeSeperators(locale: string = i18n.locale) {
        const str = this.stringify(10000.1, -1, true, locale);
        let thousandsSymbol = "";

        if (isNaN(parseInt(str.charAt(2)))) {
            thousandsSymbol = str.charAt(2);
        } else {
            thousandsSymbol = str.charAt(1);
        }

        const decimalsSymbol = str.charAt(6);
        return [thousandsSymbol, decimalsSymbol];
    }
}
